import { PatientDashboardScreen } from "@/interactors/PatientDashboardScreen";

export default function Dashboard() {
  return <PatientDashboardScreen />;
}
